import React from 'react';
import {ArrowUpRight,Server} from 'lucide-react';
import './hostinger-referral.css';

export default function HostingerReferral() {
  return <a className="hostinger-referral" href="https://www.hostinger.com?REFERRALCODE=6BMSAJIBHKZE" target="_blank" rel="sponsored noopener noreferrer" aria-label="Hostinger — Explore web hosting · Referral link (opens in a new tab)">
    <span className="hostinger-referral__top"><span className="hostinger-referral__icon"><Server size={22} aria-hidden="true"/></span><span className="hostinger-referral__name">Hostinger</span><ArrowUpRight className="hostinger-referral__arrow" size={20} aria-hidden="true"/></span>
    <span className="hostinger-referral__description">A home for your next website.</span>
    <span className="hostinger-referral__bottom"><span className="hostinger-referral__cta">Explore web hosting</span><small>Referral link</small></span>
  </a>;
}
